import { render, staticRenderFns } from "./pegasusonlineaktarim.vue?vue&type=template&id=72078ac1&"
import script from "./pegasusonlineaktarim.vue?vue&type=script&lang=js&"
export * from "./pegasusonlineaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports